// src/guide/compte/guide_modifier_mail.js
import {
  guide_tour_init,
  guide_tour_step_start,
  guide_tour_step_complete,
} from "@/guide/utils/guide_tour_actions";

export async function guide_modifier_mail(langs) {
  let translations;
  try {
    // Charge dynamiquement le JSON correspondant (ex: guide_traduction_fr.json)
    translations = (
      await import(`@/guide/traductions/guide_traduction_${langs}.json`)
    ).default;
  } catch (error) {
    console.error(
      "Erreur lors du chargement des traductions pour la langue",
      langs,
      error
    );
    return;
  }
  const tour = guide_tour_init();

  guide_tour_step_start(
    tour,
    translations,
    translations.compte.coordonnees.modifier_mail.mail.titre,
    translations.compte.coordonnees.modifier_mail.mail.texte,
    "#mail",
    "bottom"
  );

  guide_tour_step_complete(
    tour,
    translations,
    translations.compte.coordonnees.modifier_mail.valider_modification_mail
      .titre,
    translations.compte.coordonnees.modifier_mail.valider_modification_mail
      .texte,
    "#valider_modification_mail",
    "top"
  );

  tour.start();
}
